import React from 'react';
import FoundersResultsReportSubscribe from './FoundersResultsReportSubscribe';

const VMSFoundersResults: React.FC = () => {
  const KLAVIYO_LIST_ID = 'VAzWgU';
  return <FoundersResultsReportSubscribe klaviyoListId={KLAVIYO_LIST_ID} />;
};

export default VMSFoundersResults;
